import '../Sidebar/Sidebar.css'

import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import NavItem from '../NavItem/NavItem'
import useAuth from '../../hooks/useAuth'

import logo from '../../assets/images/logo-new.png'
import adminLogo from '../../assets/images/admin-logo.svg'
import AsteriskCard from '../AsteriskCard/AsteriskCard'
import useProfileCompleted from '../../hooks/useProfileCompleted'
import { AuthContext } from '../../contexts/AuthContext'
import { useContext } from 'react'

const userClasses = `
    nav-item
    fw-medium 
    text-lg 
    text-primary 
    rounded-lg 
    transition-all 
    my-6
    px-6
    py-2
    hover:bg-accent
    hover:text-white
`

const adminClasses = `
    nav-item
    fw-medium 
    text-lg 
    text-white 
    mb-2 
    py-5 
    px-4
    transition-all
`

const disabledClasses = `
    bg-grey
    fw-medium 
    text-lg 
    text-secondary 
    mb-2 
    py-3
    px-6
    rounded-lg 
    transition-all
`

const Sidebar = ({ forAdmin = false }) => {
    const { getEmailVerified } = useAuth()
    const emailVerifed = getEmailVerified()
    const { token } = useContext(AuthContext)
    const profileCompleted = useProfileCompleted(token)

    return forAdmin ? (
        <aside className="h-full bg-primary flex flex-col justify-start admin-sidebar py-4">
            <Link
                className="flex gap-5 my-10 items-center justify-center"
                to="/admin/profile"
            >
                <img width="65" height="65" src={adminLogo} alt="admin-logo" />
            </Link>

            <nav>
                <ul className="sidebar--nav-menu text-white ">
                    <NavItem
                        classes={adminClasses}
                        path="/admin/payment"
                        text="Πληρωμές Οφειλών"
                    />
                    <NavItem
                        classes={adminClasses}
                        path="/admin/balance-request"
                        text="Αιτήσεις Υπολοίπου"
                    />

                    <NavItem
                        classes={adminClasses}
                        path="/admin/add-debt"
                        text="Προσθήκη Οφειλής"
                    />
                    <NavItem
                        classes={adminClasses}
                        path="/admin/kok"
                        text="Κλήσεις Κ.Ο.Κ."
                    />
                    <NavItem
                        classes={adminClasses}
                        path="/admin/users"
                        text="Χρήστες"
                    />
                    <NavItem
                        classes={adminClasses}
                        path="/admin/govpay-info"
                        text="Govpay Info"
                    />
                </ul>
            </nav>
        </aside>
    ) : (
        <aside className="h-full flex flex-col justify-start pr-14 w-1/4 ">
            <Link to="/">
                <img width="300" height="300" src={logo} alt="logo" />
            </Link>

            <nav>
                <ul>
                    <NavItem
                        classes={userClasses}
                        path="/balance-requests"
                        text="Αίτηση Υπολοίπου και ιστορικό αιτήσεων"
                    />

                    <NavItem
                        classes={userClasses}
                        path="/payments"
                        text="Ιστορικό πληρωμών"
                    />

                    <NavItem
                        classes={emailVerifed ? userClasses : disabledClasses}
                        hasSubmenu={true}
                        text="Βεβαιώσεις - Ρυθμίσεις"
                        subMenuItems={[
                            {
                                text: 'Βεβαιωμένες Οφειλές',
                                path: '/debts/confirmed',
                            },
                            {
                                text: 'Οφειλές σε Ρύθμιση',
                                path: '/debts/installments',
                            },
                        ]}
                    />

                    <NavItem
                        classes={userClasses}
                        path="/payment"
                        text="Άμεση πληρωμή"
                    />

                    <NavItem
                        classes={emailVerifed ? userClasses : disabledClasses}
                        hasSubmenu={true}
                        text="Κλήσεις Κ.Ο.Κ"
                        subMenuItems={[
                            {
                                text: 'Οι κλήσεις μου',
                                path: '/fines',
                            },
                            {
                                text: 'Ιστορικό Κλήσεων',
                                path: '/fines-history',
                            },
                        ]}
                    />
                    <NavItem
                        classes={userClasses}
                        path="/contact-info"
                        text="Επικοινωνία - Υποστήριξη"
                    />
                </ul>
            </nav>
            {(!profileCompleted || !emailVerifed) && (
                <>
                    <AsteriskCard
                        htmlContent={`<div>Προκειμένου να έχετε πλήρη πρόσβαση στην πλατφόρμα, παρακαλούμε όπως συμπληρώσετε όλα τα επεξεργάσιμα πεδία του προφίλ <a class="font-bold" href="${'/profile'}"> εδώ </a></div>`}
                    />
                </>
            )}
        </aside>
    )
}

Sidebar.propTypes = {
    forAdmin: PropTypes.bool,
}

export default Sidebar
